export default __webpack_public_path__ + "static/media/home-travel-agency-tour-intrest-bg.42218ab6.jpg";